// Functions
	function offset(el) {
		const rect = el.getBoundingClientRect(),
			scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
			scrollTop = window.pageYOffset || document.documentElement.scrollTop;

		return {
			top: rect.top + scrollTop,
			left: rect.left + scrollLeft,
			width: rect.width,
			height: rect.height
		}
	}
	function showArticles (nodelist) {
		let allReady = true;

		const sTop = window.pageYOffset;
		const winH = window.innerHeight;

		for (let i = 0; i < nodelist.length; i++) {
			if (offset(nodelist[i]).top < sTop + winH - (winH / 6)) nodelist[i].classList.add('ready');

			if (nodelist[i].classList.contains('ready')) continue;
			else allReady = false;
		}

		if (allReady == true) {
			document.removeEventListener('scroll', offseterListeners);
		}
	}
	function offseter(nodelist, force) {
		let article, articleOffset, highest, higherPos, diff, maxDiff;

		if (window.innerWidth < 540) {
			for (var i = 0; i < nodelist.length; i++) {
				nodelist[i].style.marginTop = '';
			}
			return false;
		}

		let margin = window.getComputedStyle(nodelist[0])['margin-bottom'];
		margin = parseInt(margin.match(/\d+/)[0]);

		for (let i = 0; i < nodelist.length; i++) {
			if (nodelist[i].classList.contains('ready') && !force) continue;

			setTimeout(function () {
				article = nodelist[i];
				articleOffset = offset(article);

				article.style.transition = 'none';
				article.style.marginTop = '';

				if (window.innerWidth > 1024) {
					if (i < 3) return false; // Due to setTimeout

					switch (true) {
						case (i % 5 == 3):
						case (i % 5 == 4):
						case (i % 5 == 1):
							highest =
								offset(nodelist[i - 2]).height > offset(nodelist[i - 3]).height ?
								nodelist[i - 2] :
								nodelist[i - 3];
							break;

						case (i % 5 == 0):
							highest = nodelist[i - 2];
							break;

						case (i % 5 == 2):
							highest = nodelist[i - 3];
							break;
					}

					maxDiff = 300;
				} else if (window.innerWidth > 540) {
					if (i < 2) return false; // Due to setTimeout

					highest = nodelist[i - 2];
					maxDiff = 250;
				}

				if (highest == undefined) return false; // Due to setTimeout

				let aTop = article.style.marginTop.match(/\d+/);
				aTop = parseInt(aTop !== null ? aTop[0] : 0);

				let hTop = nodelist[i - 2].style.marginTop.match(/\d+/);
				hTop = parseInt(hTop !== null ? hTop[0] : 0);

				let diff = (offset(article).top + aTop) - (offset(highest).top + offset(highest).height + hTop) - margin;
				if (offset(article).top + aTop <= offset(highest).top + offset(highest).height + hTop) diff = 0;
				diff = Math.round(diff);

				article.style.transition = '';
				article.style.marginTop = -Math.min(Math.max(-maxDiff, diff), maxDiff) + 'px';
			}, i * (force ? 200 : 0));
		}
	}

	function offseterListeners () {
		const articleList = document.querySelectorAll('[offseter-list] > li');
		showArticles(articleList); offseter(articleList);
	}


// Execution
	$(document).ready(() => {
		if (!document.querySelector('[offseter-list]')) return false; // Cancel if there is no offseter to manager
		offseterListeners();

		document.addEventListener('scroll', offseterListeners);

		let resizeDelayer;

		window.addEventListener('resize', function () {
			clearTimeout(resizeDelayer);

			resizeDelayer = setTimeout(function () {
				offseter(document.querySelectorAll('[offseter-list] > li'), true);
			}, 700);
		});
	});


	$('[get-cta]').each(function () {
		$(this).wrapInner('<a class="textual" href="'+ $(this).parents('li').find('a.cta').attr('href') +'"></a>');
		$(this).removeAttr('get-cta');
	});